import bg from "../../../assets/cta.png";

const CallToAction = () => {
  return (
    <div>
      <div
        style={{ backgroundImage: `url(${bg})` }}
        className="bg-cover bg-center px-6 lg:px-16 py-32 lg:py-40"
      >
        <div className="lg:grid grid-cols-2 gap-48 items-center justify-between lg:ml-[143px]">
          <div className="lg:max-w-[450px] max-lg:mb-10">
            <h1 className="text-white text-[40px] leading-[54px] font-semibold lg:my-[24px]">
              Want something delivered/moved ?
            </h1>
            <span className="text-border text-lg">
              Get hassle-free shipping with ZAP! Connect with delivery agents,
              track your shipments, and say goodbye to delivery headaches.
            </span>
          </div>
          <div className="bg-accent rounded-lg w-full p-6 lg:p-10">
            <div className="my-8">
              <h1 className="font-medium text-[16px] mb-1">Current Location</h1>
              <input
                type="text"
                className="cta-btn"
                placeholder="Current Location"
              />
            </div>
            <div className="my-8">
              <h1 className="font-medium text-[16px] mb-1">Drop Location</h1>
              <input
                type="text"
                className="cta-btn"
                placeholder="Drop Location"
              />
            </div>
            <div className="mt-16">
              <button className="w-full font-medium">Proceed</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
